





































































import {Vue, Component} from 'vue-property-decorator'
import { mixins } from "vue-class-component";
import dataProxy from "@/services/data-proxy.service";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import moment from "moment";
import {formatDate, formatDateTime, formatPrice} from "@/utils/formatters";
import {DnevnoAktivnoVreme, TrosakSluzbenogPuta} from "@/services/BackendProxies";
import * as _ from 'lodash';
import TableEditorsMixin from "@/mixins/table-editors.mixin";

@Component({})
export default class NaloziZaSluzbenoPutovanje extends mixins(ComponentBaseMixin, TableEditorsMixin) {

    odDatuma = moment().startOf('month').toDate();
    doDatuma = moment().endOf('month').toDate();
    //odDatuma = new Date(2020, 4, 1);
    //doDatuma = new Date(2020, 4, 10);
    osobaId: number = null;
    mestoTroska: number = null;

    nalozi: DnevnoAktivnoVreme[] | undefined = [];
    columns = [];
    options = {
        search: false,
        pagination: true,
        showFooter: true,
        showExport: true,
        exportTypes: ['excel'],
        exportDataType: 'all',
        headerStyle: () => {return {css: {'font-size' : '10px'}}},
    };
    filterVisible = false;
    isBusy = false;
    isPrinting = false;
    pdfURL = '';
    odobrenoDodatnoVreme = 0;
    iznosDnevnice = 0;
    dijalogOtvoren = false;
    trosakSluzbenogPuta = new TrosakSluzbenogPuta();
    edit: DnevnoAktivnoVreme;

    async created() {
        const month = moment().get('month');
        const year = moment().get('year');
        this.odDatuma = new Date(year, month - 1, 26);
        this.doDatuma = new Date(year, month, 25);
        this.columns = [
            {checkbox: true, width: 25},
            {field: 'pocetakRadnogDana', title: this.$i18n.t('datum'), formatter: formatDate, width: 65},
            {field: 'broj', title: this.$i18n.t('brojNaloga'), width: 90},
            {field: 'vozac', title: this.$i18n.t('vozac'), width: 120},
            {field: 'relacija', title: this.$i18n.t('mesto'), width: 100, formatter: this.relacijaFormatter},
            {field: 'pocetakRadnogDana', title: this.$i18n.t('datumPolaska'), formatter: formatDateTime, width: 100},
            {field: 'krajRadnoDana', title: this.$i18n.t('datumZavrsetka'), formatter: formatDateTime, width: 100},
            {field: 'trajanjeRadnogDana', title: this.$i18n.t('ukupnoMinuta'), width: 40, align: 'right'},
            {field: 'trajanjeRadnogDana', title: this.$i18n.t('brojDnevnica'), width: 40,
                formatter: this.brojDnevnicaFormatter,
                footerFormatter: data => _.sumBy(data, (each: DnevnoAktivnoVreme) => this.brojDnevnicaFormatter(each.trajanjeRadnogDana, each)),
                align: 'right'
            },
            {field: 'trajanjeRadnogDana', title: this.$i18n.t('iznosDnevnice'), width: 60,
                formatter: (value, row) => formatPrice(this.brojDnevnicaFormatter(value, row) * this.iznosDnevnice),
                footerFormatter: data => formatPrice(_.sumBy(data, (each: DnevnoAktivnoVreme) => this.brojDnevnicaFormatter(each.trajanjeRadnogDana, each) * this.iznosDnevnice)),
                align: 'right'
            },
            {title: '', formatter: this.actionButtons, width: 30}
        ];
        (<any>this.options).exportOptions = {
            fileName: () => {
                return this.$i18n.t('naloziZaSluzbenoPutovanje')
            }
        };
        //this.pretraziNaloge();
    }

    toggleFilter() {
        this.filterVisible = !this.filterVisible;
    }

    get postavljenFilter() {
        return  !!this.odDatuma || !!this.doDatuma || !!this.osobaId || !!this.mestoTroska;
    }

    async pretraziNaloge() {
        try {
            this.isBusy = true;
            this.nalozi = [];
            const nalozi = await this.loadData(
                () => dataProxy.vratiDnevnaRadnaVremenaZaNalogZaSluzbenaPutovanja(
                    this.odDatuma, this.doDatuma, this.mestoTroska, this.osobaId))();
            this.nalozi = nalozi.vremena;
            this.odobrenoDodatnoVreme = nalozi.dodatnoVreme;
            this.iznosDnevnice = nalozi.iznosDnevnice;
        } finally {
            this.isBusy = false;
        }
    }

    spojiDane() {
        const selected = (<any>this.$refs.table).getAllSelections();
        let previous: DnevnoAktivnoVreme;
        for (let i = 0; i < selected.length; i++) {
            let current = selected[i];
            if (!previous) {
                previous = current;
                continue;
            }
            if (current.vozacId !== previous.vozacId) {
                this.showError(<string>this.$i18n.t('nije moguce spojiti radno vreme. vozac se razlikuje'));
                return;
            }
            const diff = moment(current.pocetakRadnogDana).diff(moment(previous.pocetakRadnogDana), 'days');
            if (diff > 1) {
                this.showError(<string>this.$i18n.t('nije moguce spojiti radno vreme. razlika datuma je razlicita od 1'));
                return;
            }
            previous = current;
        }

        const ukupnoMinuta = _.sumBy(selected, 'trajanjeRadnogDana') + this.odobrenoDodatnoVreme;
        const first: DnevnoAktivnoVreme = _.first(selected);
        const last: DnevnoAktivnoVreme = _.last(selected);
        const merged = DnevnoAktivnoVreme.fromJS({
            vozacId: first.vozacId,
            vozac: first.vozac,
            broj: `${moment(first.pocetakRadnogDana).format('YYYYMMDD')}-${first.vozacId}`,
            pocetakRadnogDana: first.pocetakRadnogDana,
            krajRadnoDana: last.krajRadnoDana,
            trajanjeRadnogDana: ukupnoMinuta,
            povezanaVremena: selected
        });
        const allRows = <DnevnoAktivnoVreme[]>(<any>this.$refs.table).getData();
        const indexOfLast = allRows.indexOf(last);
        allRows.splice(indexOfLast, 0, merged);
        const newData = _.remove(allRows, el => selected.indexOf(el) === -1);
        //(<any>this.$refs.table).load(newData);
        this.nalozi = newData;
    }

    brojDnevnicaFormatter(minuta: number, row: DnevnoAktivnoVreme) {
        if (row.povezanaVremena.length) {
            return 1.5;
        }
        if (minuta > 720) {
            return 1;
        } else if (minuta > 480) {
            return 0.5;
        } else {
            return 0;
        }
    }

    async stampaj() {
        try {
            this.isPrinting = true;
            const link = await this.loadData(() => dataProxy.vratiStampuNalogaZaSluzbenaPutnovanja(this.nalozi))();
            this.pdfURL = `${link}?t=${new Date().getUTCMilliseconds()}`
        } finally {
            this.isPrinting = false;
        }
    }

    actionButtons(value, row) {
        return this.vueFormatter({
            template: `
                <i class="fa fa-shopping-basket fa-2x text-left"
                   :class="{'text-success': row.troskoviSluzbenogPuta, 'text-muted': !row.troskoviSluzbenogPuta}"
                   @click="troskovi">
                </i>
            `,
            data: { row },
            methods: {
                troskovi: () => this.troskovi(row)
            }
        })
    }

    relacijaFormatter(value, row) {
        return this.vueFormatter({
            template: `
                <input class="form-control" v-model.lazy="row.relacija">
            `,
            data: { row }
        })
    }

    troskovi(row: DnevnoAktivnoVreme) {
        if (row.troskoviSluzbenogPuta) {
            this.trosakSluzbenogPuta.opis = row.troskoviSluzbenogPuta.opis;
            this.trosakSluzbenogPuta.iznos = row.troskoviSluzbenogPuta.iznos;
        } else {
            this.trosakSluzbenogPuta = new TrosakSluzbenogPuta();
        }
        this.edit = row;
        this.dijalogOtvoren = true;
    }

    prihvatiTrosak() {
        this.edit.troskoviSluzbenogPuta = TrosakSluzbenogPuta.fromJS(this.trosakSluzbenogPuta);
    }
}
